import graphApiSlice from 'src/shared/state/api-slices/graphApiSlice';
import {
    PortfolioMapFiltersQueryResult,
    portfolioMapFiltersQuery,
    MapMarkersResponse,
    SiteTableResponse,
    SitePopupData,
    sitePolygonsQuery,
    SitePolygonsQueryResult,
    SitePolygonData,
    mapMarkersQuery,
    MapMarkersQueryResult,
    siteTableQuery,
    SiteTableQueryResult,
    sitePopupQuery,
    SitePopupQueryResult,
    siteSpeciesRiskQuery,
    SiteSpeciesRiskQueryResult,
    SiteSpeciesRiskData,
} from './porfolioSiteExplorerQuery';

type PortfolioMapFiltersQueryParams = {
    customerId: string;
};

type SiteSpeciesRiskAssessmentQueryParams = {
    siteId: string;
    filters?: { name: string; values: string[] }[];
};

type MapMarkersQueryParams = {
    customerId: string;
    metric?: string;
    bounds?: { north: number; south: number; east: number; west: number };
    filters?: { name: string; values: string[] }[];
    pagination?: { page: number; pageSize: number };
    sortBy?: { field: string; order: 'ASC' | 'DESC' };
};

type SiteTableQueryParams = {
    customerId: string;
    metric?: string;
    filters?: { name: string; values: string[] }[];
    pagination: { page: number; pageSize: number };
    sortBy?: { field: string; order: 'ASC' | 'DESC' };
    searchText?: string;
};

type SitePopupQueryParams = {
    customerId: string;
    siteId: string;
};

type SitePolygonsQueryParams = {
    customerId: string;
    siteId: string;
};

const PortfolioSiteExplorerGraphSlice = graphApiSlice.injectEndpoints({
    endpoints: builder => ({
        portfolioMapFilters: builder.query<
            PortfolioMapFiltersQueryResult['portfolio']['getPortfolioFilters'],
            PortfolioMapFiltersQueryParams
        >({
            query: params => ({
                body: portfolioMapFiltersQuery,
                variables: params,
            }),
            transformResponse: (response: PortfolioMapFiltersQueryResult) => response.portfolio.getPortfolioFilters,
        }),

        mapMarkers: builder.query<MapMarkersResponse, MapMarkersQueryParams>({
            query: params => ({
                body: mapMarkersQuery,
                variables: params,
            }),
            transformResponse: (response: MapMarkersQueryResult) => response.portfolio.getMapMarkers,
        }),
        siteTable: builder.query<SiteTableResponse, SiteTableQueryParams>({
            query: params => ({
                body: siteTableQuery,
                variables: params,
            }),
            transformResponse: (response: SiteTableQueryResult) => response.portfolio.getSiteTable,
        }),
        sitePopup: builder.query<SitePopupData, SitePopupQueryParams>({
            query: params => ({
                body: sitePopupQuery,
                variables: params,
            }),
            transformResponse: (response: SitePopupQueryResult) => response.portfolio.getSitePopup,
        }),

        siteSpeciesRisk: builder.query<SiteSpeciesRiskData, SiteSpeciesRiskAssessmentQueryParams>({
            query: params => ({
                body: siteSpeciesRiskQuery,
                variables: params,
            }),
            transformResponse: (response: SiteSpeciesRiskQueryResult) => response.siteSummary.getSiteSpeciesRisk,
        }),

        sitePolygons: builder.query<SitePolygonData[], SitePolygonsQueryParams>({
            query: params => ({
                body: sitePolygonsQuery,
                variables: params,
            }),
            transformResponse: (response: SitePolygonsQueryResult) => response.portfolio.getSitePolygons,
        }),
    }),
});

export const {
    usePortfolioMapFiltersQuery,
    useSitePolygonsQuery,
    useLazySitePolygonsQuery,
    useMapMarkersQuery,
    useSiteTableQuery,
    useSitePopupQuery,
    useSiteSpeciesRiskQuery,
} = PortfolioSiteExplorerGraphSlice;

export default PortfolioSiteExplorerGraphSlice.reducer;
